import type { DialogStore } from "@ariakit/react";
import { createStrictContext } from "@indietabletop/appkit";

export const [SidenavContext, useSidenavStore] =
  createStrictContext<DialogStore>();
